module.exports = __webpack_public_path__ + "static/media/item5.f8e45b63.jpg";